import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Tv } from 'lucide-react';
import Toggle from '../ui/Toggle';
import useInstanceRecord from '../../hooks/useInstanceRecord';
import { useTranslation } from '../../hooks/useTranslation.jsx';

// Näyttöohjaus (settings.screenControl): whether /screen drives the wall
// screens. It decides how the devices on this page behave, so it lives here.
const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 6px 24px;
  border-bottom: 1px solid #1f1f1f;
  color: #ccc;
  font-size: 13px;
`;

const Hint = styled.span`
  color: #777;
  font-size: 12px;
`;

const ErrorText = styled.span`
  color: #f87171;
  font-size: 12px;
`;

export default function ScreenControlToggle({ instanceId }) {
  const { t } = useTranslation();
  const { instance, setValue } = useInstanceRecord(instanceId);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const on = Boolean(instance?.settings?.screenControl);

  const change = async (next) => {
    setBusy(true);
    setError(null);
    try {
      await setValue('settings', 'screenControl', next);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Bar>
      <Tv size={14} style={{ opacity: 0.7 }} />
      {t('workshopLiveControls.screenControlLabel')}
      <Toggle on={on} onChange={change} disabled={busy || !instance} label={t('workshopLiveControls.screenControlLabel')} />
      <Hint>{t('workshopLiveControls.screenControlHint')}</Hint>
      {error && <ErrorText>{error}</ErrorText>}
    </Bar>
  );
}
